import styled from './styled';
import type {CSS, CSSProperties} from './types';

export default styled;
export type {CSS, CSSProperties};
export {styled};
export {isFirefox} from './browserDetection';
export {REDUCED_MOTION, useReducedMotion} from './a11y';
export type {ColorMap} from './colors';
export {DarkModeProvider, useColors, useSetBackground} from './colors';
export {useCSS} from './useCSS';
